import { render, staticRenderFns } from "./educationEdit.vue?vue&type=template&id=ac9b1e94"
import script from "./educationEdit.vue?vue&type=script&lang=js"
export * from "./educationEdit.vue?vue&type=script&lang=js"
import style0 from "./educationEdit.vue?vue&type=style&index=0&id=ac9b1e94&prod&lang=less&rel=stylesheet%2Fless"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports